import React from 'react'
import Label from './fields/Label'

export default function FieldTemplate(props) {
  const {
    id,
    classNames,
    label,
    children,
    errors,
    help,
    description,
    hidden,
    required,
    displayLabel,
    uiSchema,
  } = props

  if (hidden) {
    return children
  }
  const wrapperProps = {
    className: classNames,
  }
  if (uiSchema['ariaHidden']) {
    wrapperProps['aria-hidden'] = true
  }

  return (
    <div className={classNames}>
      {displayLabel && (
        <Label
          label={label}
          required={required}
          id={id}
          isHTML={uiSchema['html']}
        />
      )}
      {displayLabel && description ? description : null}
      {children}
      {errors}
      {help}
    </div>
  )
}
